// extracted by mini-css-extract-plugin
module.exports = {"root":"_2azMB","bg":"_1np62","bg2":"_3-Np-"};